module.exports = __webpack_public_path__ + "static/deaths.7db72ab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/deaths.png
// module id = 1395
// module chunks = 187008205646598